var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "Nhập nhân viên từ Excel",
        visible: _vm.dialogVisibleExEmployee,
        width: "80%",
        "before-close": _vm.closeDialog,
        "close-on-click-modal": false,
        "custom-class": "sk-dialog",
        top: "5vh",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisibleExEmployee = $event
        },
      },
    },
    [
      _c("div", { staticClass: "sk-dialog-content" }, [
        _c(
          "div",
          { staticClass: "sk-panel", staticStyle: { "margin-bottom": "16px" } },
          [
            _c("div", { staticClass: "sk-panel-head" }, [
              _c("div", { staticClass: "sk-panel-icon" }, [
                _c("i", { staticClass: "el-icon-upload" }),
              ]),
              _c("div", [
                _c("p", { staticClass: "sk-panel-title" }, [
                  _vm._v("Tải lên file Excel"),
                ]),
                _c("p", { staticClass: "sk-panel-subtitle" }, [
                  _vm._v(
                    "\n            Chọn file Excel theo đúng mẫu để nhập dữ liệu nhân sự hàng loạt.\n          "
                  ),
                ]),
              ]),
            ]),
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "align-items": "center",
                  gap: "12px",
                  "flex-wrap": "wrap",
                },
              },
              [
                _c("upload-excel", {
                  attrs: {
                    "on-success": _vm.handleSuccess,
                    "before-upload": _vm.beforeUpload,
                  },
                }),
                _c(
                  "el-button",
                  {
                    staticStyle: { "border-radius": "10px" },
                    attrs: { size: "mini", type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.dowloadFile()
                      },
                    },
                  },
                  [
                    _c(
                      "a",
                      {
                        staticStyle: {
                          "text-decoration": "none",
                          color: "white",
                        },
                        attrs: {
                          href: "https://media.onekids.edu.vn/sysfiles/other/MAU_QUAN_LY_NHAN_SU.xlsx",
                        },
                      },
                      [_vm._v("Tải mẫu File")]
                    ),
                  ]
                ),
              ],
              1
            ),
            _vm.tableData.length > 0
              ? _c(
                  "div",
                  {
                    staticClass: "sk-note",
                    staticStyle: { "margin-top": "12px" },
                  },
                  [
                    _c("i", { staticClass: "el-icon-success" }),
                    _c("span", [
                      _vm._v("Đã đọc "),
                      _c("strong", [_vm._v(_vm._s(_vm.tableData.length))]),
                      _vm._v(
                        " bản ghi từ file.\n          Kiểm tra dữ liệu bên dưới trước khi nhập."
                      ),
                    ]),
                  ]
                )
              : _vm._e(),
          ]
        ),
        _vm.tableData.length > 0
          ? _c(
              "div",
              [
                _c(
                  "el-table",
                  {
                    staticStyle: {
                      "font-size": "12px",
                      "border-radius": "12px",
                      overflow: "hidden",
                    },
                    attrs: {
                      data: _vm.tableData,
                      border: "",
                      "max-height": "480",
                      "highlight-current-row": "",
                      "header-cell-style": _vm.tableHeaderColor,
                    },
                  },
                  _vm._l(_vm.tableHeader, function (item) {
                    return _c("el-table-column", {
                      key: item,
                      staticStyle: { "font-size": "10px" },
                      attrs: { prop: item, label: item },
                    })
                  }),
                  1
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
      _c(
        "span",
        {
          staticClass: "sk-dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              staticClass: "btn-cancel",
              attrs: { type: "danger", size: "medium" },
              on: {
                click: function ($event) {
                  return _vm.closeDialog()
                },
              },
            },
            [
              _c("i", { staticClass: "el-icon-circle-close" }),
              _c("span", [_vm._v(_vm._s(_vm.$t("button.close")))]),
            ]
          ),
          _c(
            "el-button",
            {
              staticClass: "btn-save",
              attrs: {
                disabled: _vm.tableData.length == 0,
                type: "success",
                size: "medium",
                loading: _vm.loadingExcelButton,
              },
              on: {
                click: function ($event) {
                  return _vm.handleCreateEmployee()
                },
              },
            },
            [
              _c("i", { staticClass: "el-icon-circle-check" }),
              _c("span", [_vm._v("Thêm dữ liệu")]),
            ]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }